import React from 'react';
import { Link } from 'react-router-dom';
import { heroImage, aboutImage } from '../mock';
import Seo from '../components/Seo';

const About = () => {
  return (
    <main className="max-w-[1100px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo
        title="About Vial Rat Research Co. | Canadian Research Peptide Supplier"
        description="Vial Rat Research Co. is a Canadian supplier of research peptides and laboratory materials. Learn about our approach to research-grade specimens."
        canonicalPath="/about"
      />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">BRAND FILE #001</div>
      <h1 className="font-serif-display text-white text-6xl md:text-7xl">Meet Vial Rat</h1>

      <div className="mt-12 grid md:grid-cols-2 gap-10 items-start">
        <img src={heroImage} alt="Vial Rat mascot" className="rounded-xl border border-white/10" />
        <div className="space-y-6 text-neutral-300 leading-relaxed">
          <p>Somewhere in a very beige Canadian research facility, under humming fluorescent tubes, a small white rat looked around at the labels. Grey boxes. Serial numbers. Fonts chosen by someone who has never once been excited about anything.</p>
          <p>He decided this was, scientifically speaking, tragic.</p>
          <p>So he took a lab coat two sizes too big, pocketed a single vial, and walked out through a door somebody definitely should have locked. He kept the standards. He threw out the styling.</p>
          <p>VIAL RAT RESEARCH CO. is what he built: Canadian research materials, catalogued properly, packaged discreetly, and presented like something you would actually want on your bench. Chrome, hot pink, and absolutely no beige.</p>
          <p className="font-serif-display text-white text-2xl italic">Serious about research. Not serious about being boring.</p>
          <Link to="/shop" className="inline-block btn-pink px-7 py-4 rounded font-mono-label text-[11px] mt-2">SHOP THE LAB</Link>
        </div>
      </div>

      <div className="mt-16">
        <img src={aboutImage} alt="Research vials in a rack" className="rounded-xl border border-white/10 w-full" />
      </div>

      <div className="mt-16">
        <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-6">HOUSE RULES</div>
        <ul className="space-y-3 text-lg text-neutral-200 font-serif-display">
          <li>— Canadian based, Canadian shipped.</li>
          <li>— Research materials only.</li>
          <li>— Discreet packaging, always.</li>
          <li>— No medical claims. Ever.</li>
        </ul>
      </div>

      <div className="mt-16 p-6 border border-[#ff2fa1]/20 bg-[#ff2fa1]/5 rounded">
        <div className="font-mono-label text-[11px] text-[#ff2fa1]">FOR RESEARCH USE ONLY</div>
        <p className="text-sm text-neutral-400 mt-2">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default About;
